"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStandaloneProperty = exports.standalonePropertyDefinition = void 0;
exports.standalonePropertyDefinition = {
    view: {
        label: 'Show on automatic feeds',
        style: '',
        hint: 'Default is pre-filled. Tick the box if you want to make the asset appear on collection and search pages.',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
    ],
    type: 'boolean',
    multiple: false,
    default: false,
    name: 'standalone',
};
const isStandaloneProperty = (prop) => {
    return prop.name === exports.standalonePropertyDefinition.name;
};
exports.isStandaloneProperty = isStandaloneProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhbmRhbG9uZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3N0YW5kYWxvbmUucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw0QkFBNEIsR0FBRztJQUMxQyxJQUFJLEVBQUU7UUFDSixLQUFLLEVBQUUseUJBQXlCO1FBQ2hDLEtBQUssRUFBRSxFQUFFO1FBQ1QsSUFBSSxFQUFFLDBHQUEwRztLQUNqSDtJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtLQUNGO0lBQ0QsSUFBSSxFQUFFLFNBQVM7SUFDZixRQUFRLEVBQUUsS0FBSztJQUNmLE9BQU8sRUFBRSxLQUFLO0lBQ2QsSUFBSSxFQUFFLFlBQVk7Q0FDYSxDQUFBO0FBSTFCLE1BQU0sb0JBQW9CLEdBQUcsQ0FBQyxJQUFrQixFQUE4QixFQUFFO0lBQ3JGLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxvQ0FBNEIsQ0FBQyxJQUFJLENBQUE7QUFDeEQsQ0FBQyxDQUFBO0FBRlksUUFBQSxvQkFBb0Isd0JBRWhDIn0=